import { useEffect } from "react";
import { Modal, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { useRuleHistoryQuery } from "../../../rules/ruleEditor/components/RuleDetailsPopup/useRuleHistoryQuery";
import RuleHistoryTable from "../../../rules/ruleEditor/components/RuleDetailsPopup/RuleHistoryTable";

/**
 * Details popup for the SavedSearchView (a.k.a. custom report) page.
 * Shows the rule's change history only — no Activate/Deactivate or
 * Clone sections, because those flows aren't applicable to advanced
 * search / custom report rules (different endpoints).
 *
 * History is fetched lazily via useRuleHistoryQuery — only while the
 * modal is open.
 */
export default function SavedSearchDetailsPopup({ ruleId, opened, onClose }) {
  const { t } = useTranslation();
  const { data: history, error: historyError } = useRuleHistoryQuery({
    ruleId,
    enabled: opened,
  });

  useEffect(() => {
    if (opened && historyError) toast.error("error");
  }, [opened, historyError]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Details"
      size={1300}
      centered
    >
      <Stack gap="md">
        <Text fw={500} ta="center">
          {t("multipleSearch.detailsPopup.changeHistory")}
        </Text>
        <RuleHistoryTable history={history} currentRuleId={Number(ruleId)} />
      </Stack>
    </Modal>
  );
}
